import './App.css';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { AvanceImmediate } from './components/AvanceImmediate';
import { FAQ } from './components/FAQ';
import { About } from './components/About';
import { ZonesIntervention } from './components/ZonesIntervention';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { Toaster } from './components/ui/sonner';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <AvanceImmediate />
      <FAQ />
      <About />
      <ZonesIntervention />
      <Contact />
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
}

export default App;